import { EmptyComponentWithDataTestId } from '@app/components';
import { ClientStatusEnum } from '@app/components/RecordModal/components/RecordDetails/types';
import { FinalTechMapTable } from '@app/components/RecordModal/components/TechnologicalMap/components';
import { selectRecordModal } from '@app/components/RecordModal/model/selectors';
import { ClientServiceProductUsages } from '@app/pages/Clients/EditClientService/components';
import { useAppSelector } from '@app/store';

export const useTechnologicalMap = () => {
  const { record, isFullyPaid } = useAppSelector(selectRecordModal);

  const isVisitedAndFullyPaid =
    record?.Status === ClientStatusEnum.VISITED &&
    (record?.IsPaid || isFullyPaid);

  const isCostZero = record?.IsCostZero;

  const getTechnologicalMapContent = () => {
    if (isVisitedAndFullyPaid || isCostZero) {
      return <FinalTechMapTable />;
    }

    if (!record?.ClientServices.length) {
      return <EmptyComponentWithDataTestId />;
    }

    return record?.ClientServices.map(({ Id, Name }) => (
      <ClientServiceProductUsages key={Id} serviceId={Id} serviceName={Name} />
    ));
  };

  return { getTechnologicalMapContent };
};
